export const SHIPPING_METHOD_TYPE = {
  HOME_DELIVERY: 'home_delivery',
  CVS_711: 'cvs_711',
  CVS_FAMILY: 'cvs_family',
  PALLET: 'pallet',
  SF_BUSINESS_POINT: 'sf_business_point',
  SF_LOCKER: 'sf_locker',
  SF_PARTNER_STORE: 'sf_partner_store',
  CVS_FAMILY_COMMUNITY: 'cvs_family_community',
} as const

export const SHIPPING_METHODS_CONFIGS = [
  {
    type: SHIPPING_METHOD_TYPE.HOME_DELIVERY,
    display_name: '宅配',
    description: '配送至顧客指定的地址',
  },
  {
    type: SHIPPING_METHOD_TYPE.CVS_711,
    display_name: '超商取貨 (7-11)',
    description: '配送至指定統一超商，目前僅台灣支援超商取貨',
  },
  {
    type: SHIPPING_METHOD_TYPE.CVS_FAMILY,
    display_name: '超商取貨 (全家)',
    description: '配送至指定全家超商，目前僅台灣支援超商取貨',
  },
  {
    type: SHIPPING_METHOD_TYPE.PALLET,
    display_name: '棧板出貨',
    description: '使用棧板出貨，適合顧客下訂大宗貨品',
  },
]

export const DeliveryClass = {
  NORMAL: 'normal',
  FROZEN: 'frozen',
  SUBSHIP: 'subship',
  DONATION: 'donation',
} as const

export const DELIVERY_CLASS_MAPPING = {
  [DeliveryClass.NORMAL]: '常溫商品',
  [DeliveryClass.FROZEN]: '冷凍商品',
  [DeliveryClass.SUBSHIP]: '寄倉商品',
  [DeliveryClass.DONATION]: '公益商品',
}

// TODO:待確認排除運送類別選項
export const ExcludeShippingClassEnum = {
  FROZEN_NO_SHOP: 'frozen_no_shop',
  FROZEN_NO_PARTNER: 'frozen_no_partner',
  NORMAL_TAIWAN_NO_SHOP: 'normal_taiwan_no_shop',
  NORMAL_TAIWAN_NO_SHOP_PARTNER: 'normal_taiwan_no_shop_partner',
  NORMAL_TAIWAN_NO_PARTNER: 'normal_taiwan_no_partner',
  NORMAL_NO_PARTNER: 'normal_no_partner',
  NO_CUSTOMER: 'no_customer',
  PROMOTE_2B: '2b_promote',
} as const

export const EXCLUDE_SHIPPING_CLASS_MAPPING = {
  [ExcludeShippingClassEnum.FROZEN_NO_SHOP]: '冷凍商品，不可超取',
  [ExcludeShippingClassEnum.FROZEN_NO_PARTNER]: '冷凍商品，經銷不能結帳',
  [ExcludeShippingClassEnum.NORMAL_TAIWAN_NO_SHOP]: '台灣限定常溫商品，不可超取',
  [ExcludeShippingClassEnum.NORMAL_TAIWAN_NO_SHOP_PARTNER]: '台灣限定常溫商品，不可超取，經銷不能結帳',
  [ExcludeShippingClassEnum.NORMAL_TAIWAN_NO_PARTNER]: '台灣限定常溫商品，經銷不能結帳',
  [ExcludeShippingClassEnum.NORMAL_NO_PARTNER]: '常溫商品，經銷不能結帳',
  [ExcludeShippingClassEnum.NO_CUSTOMER]: '純經銷商品，一般客人不能結帳',
  [ExcludeShippingClassEnum.PROMOTE_2B]: '經銷活動商品，不受限於4000出貨門檻',
}
